import { AvatarGroup, Box, Grid2, Stack, useTheme } from '@mui/material';
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { lighter } from '../common/util';
import ScoreAvatar from '../enrollment/score.avatar';
import SubjectAvatar from '../subject/subject.avatar';

export default function TermStudentCard(props) {
	const theme = useTheme();

	const [student, setStudent] = useState(props.student);
	useEffect(() => {
		setStudent(props.student);
	}, [props.student]);

	if (!student?.name) {
		return;
	}

	let subtext = '';
	let subjectAvatars = '';
	let completeness = 0;
	if (student?.enrollments?.length) {
		completeness = _.sumBy(student?.enrollments, 'completeness') / student.enrollments.length;

		subtext = <Typography variant="subtitle1">{_.uniqBy(student.enrollments, 'course.subjectId').length} Subjects, {student.enrollments?.length} Courses</Typography>

		// 	<Badge overlap="circular" anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} badgeContent={enrollments.length > 1 ? enrollments.length : null} color="primary" sx={{mr: enrollments.length > 1 ? 2: null}}>
		subjectAvatars = _.chain(student.enrollments).sortBy('course.subject.name').reverse().groupBy('course.subjectId').map( (enrollments, subjectId) => (
			<SubjectAvatar subject={enrollments[0].course.subject} size={28} key={enrollments[0].course.subjectId} />
		)).value();
	}

	let score = 0;
	if (student?.enrollments?.length) {
		const enrollments = _.filter(student?.enrollments, 'score'); //Don't count zeros
		if (enrollments.length) {
			score = _.sumBy(enrollments, 'score') / enrollments.length;
		}
	}

	const progressSx = {
		flexGrow: 1,
		height: 12,
		'.MuiLinearProgress-bar1Buffer':{backgroundColor:lighter(student.colour, 0.2, theme)},
		'.MuiLinearProgress-bar2Buffer':{backgroundColor:lighter(student.colour, 0.6, theme)},
	};

	const cardMediaSx = { height: '100%', aspectRatio: '1 / 1' };
	const cardMedia = (
		<CardMedia sx={cardMediaSx} component="img" src={student.profilePicture || '/missing-student.png'} />
	);

	const cardContent = (
		<CardContent sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, p: 2 }}>
			<Stack spacing={1}>
				<Box sx={{ flex: 1 }}>
					<Typography variant="h6">{student.name}</Typography>
					{subtext}
					<AvatarGroup max={10000} sx={{flexDirection: 'row', '.MuiAvatar-root, .MuiAvatar-root:last-child': {ml: -2}}}>
						{subjectAvatars}
					</AvatarGroup>	
				</Box>
				<ScoreAvatar score={score} size={32} />
			</Stack>

			{/* <Box sx={{ flexGrow: 1 }}></Box>
			{completeness > 0 &&
				<Box sx={{ ml: -6, mr: -5 }}>
					<Typography variant="subtitle2" sx={{ml: (completeness - 3) + '%'}}>{completeness.toFixed(0)}%</Typography>
					<LinearProgress title={completeness.toFixed(0) + '% Complete'} variant="buffer" value={completeness} valueBuffer={100} sx={progressSx} color="info" />
				</Box>
			} */}
		</CardContent>
	);

	let cardDetail = (
		<Grid2 container sx={{ width: '100%' }}>
			<Grid2 size={2}>
				{cardMedia}
			</Grid2>
			<Grid2 size={10} sx={{ display: 'flex', pb: 2 }}>
				{cardContent}
			</Grid2>
		</Grid2>
	);

	const cardSx = { width: '100%', outline: '2px solid ' + lighter(student.colour, 0.8, theme) };
	return (
		<Card sx={cardSx} className="hover-toggle">
			{cardDetail}
		</Card>
	);
}